// extracted by css-extract-rspack-plugin
export default {"form":"KKKMjpq9wUBsNkia","field":"NscZzyPtqJoY7_VN","label":"Yi4Zq0POMgIZqdo7"};